"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.infiniteLoopErrorType = exports.StackOverflowMessages = exports.InfiniteLoopErrorMessage = void 0;
var InfiniteLoopErrorMessage;
(function (InfiniteLoopErrorMessage) {
    InfiniteLoopErrorMessage["no_base_case"] = "Did you forget your base case?";
    InfiniteLoopErrorMessage["input_out_of_domain"] = "Did you call a value that is outside the range of your function?";
    InfiniteLoopErrorMessage["no_state_change"] = "Check your recursive function calls.";
    InfiniteLoopErrorMessage["source_protection_loop"] = "Potential infinite loop detected";
    InfiniteLoopErrorMessage["source_protection_recursion"] = "Potential infinite recursion detected";
})(InfiniteLoopErrorMessage = exports.InfiniteLoopErrorMessage || (exports.InfiniteLoopErrorMessage = {}));
var StackOverflowMessages;
(function (StackOverflowMessages) {
    StackOverflowMessages["firefox"] = "InternalError: too much recursion";
    // webkit: chrome + safari
    StackOverflowMessages["webkit"] = "RangeError: Maximum call stack size exceeded";
    StackOverflowMessages["edge"] = "Error: Out of stack space";
})(StackOverflowMessages = exports.StackOverflowMessages || (exports.StackOverflowMessages = {}));
/**
 * Parses the error and determines whether it is an infinite loop and
 * if so, what kind of infinite loop.
 *
 * @returns {string} string containing the infinite loop classification.
 * @returns {string} empty string, if the error is not an infinite loop.
 */
function infiniteLoopErrorType(errorString) {
    const infiniteLoopTypes = Object.entries(InfiniteLoopErrorMessage);
    const stackOverflowStrings = Object.values(StackOverflowMessages);
    for (const [type, message] of infiniteLoopTypes) {
        if (errorString.includes(message))
            return type;
    }
    for (const message of stackOverflowStrings) {
        if (errorString === message)
            return 'stack_overflow';
    }
    return '';
}
exports.infiniteLoopErrorType = infiniteLoopErrorType;
//# sourceMappingURL=errorMessages.js.map